// eslint-disable-next-line @typescript-eslint/no-deprecated
import { useFeatureGate as useStatsigFeatureGate } from '@/src/services/Statsig/PlatformStatsig'
import { useStatsigLoadingStatus } from '@/src/services/Statsig'

// eslint-disable-next-line @typescript-eslint/no-deprecated
export function useFeatureGate(...props: Parameters<typeof useStatsigFeatureGate>) {
  const loadingStatus = useStatsigLoadingStatus()

  // eslint-disable-next-line @typescript-eslint/no-deprecated
  const featureGate = useStatsigFeatureGate(...props)

  switch (loadingStatus) {
    case 'Ready':
      return { loadingStatus, featureGate } as const
    default:
      return { loadingStatus } as const
  }
}
